<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Icon, Stack, Text } from '@Shelly/shelly-design-system';
	import { deviceMainFilter } from 'src/stores/ui/filters';

	export let search = '';
	export let marginTop = '0';
	export let marginTopMd = '0';
</script>

<Stack gap="s" align="center" class="text-center">
	<div class="text-center">
		<Icon
			icon="fa-light fa-magnifying-glass"
			class="mt-{marginTop} mt-md-{marginTopMd} mb-s"
			size="l"
		/>
	</div>
	<h1 class="h1-styles text-white">
		{$format('no_results_for_search_param', {
			default: 'No results for ‘{search}’',
			values: { search: search ? search : $deviceMainFilter },
		})}
	</h1>
	<Text class="body-styles text-color-muted">
		{$format('check_the_spelling_or_try_new_search', {
			default: 'Check the spelling or try a new search.',
		})}
	</Text>
</Stack>
